import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const bot = createAction(types.BOT, (bot: any[]) => ({
    payload: bot, 
}));
